module.exports = __webpack_public_path__ + "img/main7.d2ff96c7.png";